import { XClose } from "@untitledui/icons";
import { formatCreatorIdShort } from "@/utils/formatters";

interface CreatorTagProps {
  creatorId: string;
  handle?: string | null;
  thumbnail: string | null;
  onRemove?: () => void;
  onClick?: () => void;
  active?: boolean;
  disabled?: boolean;
}

export const CreatorTag = ({ creatorId, handle, thumbnail, onRemove, onClick, active, disabled }: CreatorTagProps) => {
  const isClickable = onClick && !disabled;
  const displayLabel = handle ?? (formatCreatorIdShort(creatorId) || "Unknown creator");
  return (
    <div
      role={isClickable ? "button" : undefined}
      onClick={isClickable ? onClick : undefined}
      className={`pl-[5px] pr-1 py-0.5 bg-secondary rounded-md ring-1 ring-inset inline-flex justify-center items-center gap-[3px] shrink-0 ${active ? "ring-emerald-500 ring-2" : "ring-primary"} ${isClickable ? "cursor-pointer" : ""}`}
    >
      <div className="flex justify-start items-center gap-[5px]">
        {thumbnail && (
          <img
            className="w-4 h-4 shrink-0 relative rounded-full border-[0.67px] border-black/10"
            src={thumbnail}
            alt={displayLabel}
          />
        )}
        <div className="text-sm font-medium text-secondary leading-5">{displayLabel}</div>
      </div>
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          disabled={disabled}
          className="p-0.5 rounded-[3px] inline-flex items-center justify-center hover:bg-tertiary disabled:opacity-50 transition-colors"
        >
          <XClose className="w-3 h-3 text-quaternary" strokeWidth={1.5} />
        </button>
      )}
    </div>
  );
};
